export const selectTheme = {
  list: {
    padding: 'var(--quarter-rem)',
  },
  overlay: {
    borderRadius: 'var(--border-radius)',
  },
  extend: {
    agility: {},
  },
  colorScheme: {
    light: {
      overlay: {
        background: 'var(--white)',
        shadow: 'var(--overlay-box-shadow)',
      },
      clearIcon: {
        color: '#94a3b8',
      },
    },
    dark: {
      overlay: {
        background: 'var(--p-surface-900)',
        shadow: 'var(--overlay-box-shadow)',
      },
      clearIcon: {
        color: '#94a3b8',
      },
    },
  },
  css: ({ dt }: any) => `
  .p-select-label {
    line-height: normal;
  }
  p-select {
    display: flex !important;
  }
  `,
};
